import { useEffect, useState } from "react";
import { Inbox, CheckCircle2, Circle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

const SERVICE_LABELS = { service_menu: "Compilazione menù", service_website: "Sito web", service_ecommerce: "E-commerce", "": "Gadget QR" };

export const AdminInfoRequests = () => {
  const [items, setItems] = useState(null);
  const [showHandled, setShowHandled] = useState(false);

  useEffect(() => {
    api.get("/admin/info-requests").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  const toggle = async (id) => {
    try {
      const { data } = await api.put(`/admin/info-requests/${id}`);
      setItems((prev) => prev.map((i) => (i.id === id ? { ...i, handled: data.handled } : i)));
    } catch {
      toast.error("Aggiornamento non riuscito");
    }
  };

  const visible = (items || []).filter((i) => showHandled || !i.handled);
  const openCount = (items || []).filter((i) => !i.handled).length;

  return (
    <div className="rounded-2xl mo-card overflow-hidden" data-testid="admin-requests">
      <div className="px-6 py-4 border-b border-gray-100 flex flex-wrap items-center justify-between gap-3">
        <h3 className="font-display font-semibold text-2xl flex items-center gap-2">
          <Inbox className="h-5 w-5 text-[#5aa469]" /> Richieste clienti
          {openCount > 0 && <span className="text-xs font-semibold bg-amber-100 text-amber-800 px-2 py-0.5 rounded-full" data-testid="requests-open-count">{openCount} da gestire</span>}
        </h3>
        <label className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer">
          <input type="checkbox" checked={showHandled} onChange={(e) => setShowHandled(e.target.checked)} className="accent-[#5aa469]" data-testid="requests-show-handled" />
          Mostra anche gestite
        </label>
      </div>
      {items === null ? <div className="flex justify-center py-10"><Loader2 className="h-5 w-5 animate-spin text-[#5aa469]" /></div> : (
        <ul className="divide-y divide-gray-100">
          {visible.map((i) => (
            <li key={i.id} className={`px-6 py-4 flex gap-4 ${i.handled ? "opacity-60" : ""}`} data-testid={`request-${i.id}`}>
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-xs font-medium text-[#4a8a56] bg-[#5aa469]/12 px-2 py-0.5 rounded-full">{SERVICE_LABELS[i.service] || i.service}</span>
                  <span className="font-medium">{i.name}</span>
                  {i.business && <span className="text-sm text-gray-500">· {i.business}</span>}
                  <span className="text-xs text-gray-400 ml-auto">{new Date(i.created_at).toLocaleString("it-IT")}</span>
                </div>
                <div className="text-sm text-gray-500 mt-1">
                  <a href={`mailto:${i.email}`} className="text-[#5aa469] hover:underline">{i.email}</a>{i.phone && ` · ${i.phone}`}
                </div>
                <p className="text-sm text-gray-700 mt-2 whitespace-pre-wrap">{i.message}</p>
              </div>
              <Button variant="ghost" size="sm" onClick={() => toggle(i.id)} className={i.handled ? "text-gray-500" : "text-[#5aa469] hover:bg-[#5aa469]/10"} data-testid={`request-toggle-${i.id}`}>
                {i.handled ? <><Circle className="h-4 w-4 mr-1" />Riapri</> : <><CheckCircle2 className="h-4 w-4 mr-1" />Gestita</>}
              </Button>
            </li>
          ))}
          {visible.length === 0 && <li className="px-6 py-10 text-center text-gray-400 text-sm">Nessuna richiesta {showHandled ? "" : "da gestire"}.</li>}
        </ul>
      )}
    </div>
  );
};
